export const APP_SOURCE_CHROME_EXTENSION = 'chrome_extension';
export const APP_SOURCE_WEBSITE = 'website';
export const APP_SOURCE_SLACK_DESKTOP = 'slack_desktop';

export const SIGNUP_SOURCE_VIDEO_JOIN_REQUEST = 'video_join_request';
export const SIGNUP_SOURCE_WORKSPACE_JOIN_REQUEST = 'workspace_join_request';

// Turn this on to have analytics printed in the console
export const DEBUG_ANALYTICS = false;

export const APP_SOURCE_MAP = {
  WEB: 'web',
  WEB_MOBILE: 'web:mobile',
  WEB_TABLET: 'web:tablet',
  WEB_DESKTOP: 'web:desktop',
  WEB_TV: 'web:tv',
  SLACK_DESKTOP: 'slack:desktop',
  MOBILE_IOS: 'mobile:ios',
  MOBILE_ANDROID: 'mobile:android',
};
